import { Field, FormRenderProps } from "@progress/kendo-react-form";
import { Label } from "@progress/kendo-react-labels";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useState } from "react";
import { requiredValidator } from "../../../validators";
import { FormDropDownList } from "../../form";
import { Configuration } from "./Configuration";
import { CreateNewMarginDialog } from ".";

interface IProductMarginsSelector {
  formRenderProps: FormRenderProps;
  configurations: Configuration[];
  margins: any[];
  onMarginsUpdate: () => void;
}

export const ProductMarginsSelector = ({
  formRenderProps,
  configurations,
  margins,
  onMarginsUpdate,
}: IProductMarginsSelector) => {
  const getMarginsList = (commodityId: number, businessTypeId: number) => {
    return (margins ?? [])
      .filter((m: any) => m.businessTypeId === businessTypeId)
      .filter((m: any) => !m.commodityId || m.commodityId === commodityId)
      .map((m: any) => ({ value: m.marginId, label: m.longName }))
      .sort((a: any, b: any) => a.label.localeCompare(b.label));
  };

  const [activeConfig, setActiveConfig] = useState<Configuration | null>(null);

  const handleSaveMargins = (productId: number, marginId: number, marginName: string) => {
    formRenderProps.onChange(`marginSelection_${productId}`, {
      value: { value: marginId, label: marginName },
    });
    onMarginsUpdate();
    setActiveConfig(null);
  };

  return (
    <>
      <GridLayout
        align={{ vertical: "bottom" }}
        gap={{ rows: 0, cols: 5 }}
        cols={[{ width: "10%" }, { width: "40%" }, { width: "30%" }, { width: "10%" }]}
        style={{ marginTop: "1rem" }}
      >
        <GridLayoutItem col={2} row={1}><Label style={{ fontWeight: "bolder" }}>Product</Label></GridLayoutItem>
        <GridLayoutItem col={3} row={1}><Label style={{ fontWeight: "bolder" }}>Margin</Label></GridLayoutItem>

        {configurations.map((config, index) => (
          <>
            <GridLayoutItem col={2} row={index + 2} key={`config_${index}`}>
              <div>{config.commodity}</div>
              <div>{config.instrument}</div>
            </GridLayoutItem>

            <GridLayoutItem col={3} row={index + 2} key={`margin_${index}`}>
              <Field
                key={`marginSelection_${config.productId}`}
                name={`marginSelection_${config.productId}`}
                component={FormDropDownList}
                validator={requiredValidator}
                data={getMarginsList(config.commodityId, config.businessTypeId)}
                textField="label"
                dataItemKey="value"
              />
            </GridLayoutItem>

            <GridLayoutItem col={4} row={index + 2} key={`action_${index}`}>
              <a href="#" onClick={() => setActiveConfig(config)}>
                Create New
              </a>
            </GridLayoutItem>
          </>
        ))}
      </GridLayout>

      {activeConfig && (
        <CreateNewMarginDialog
          configuration={activeConfig}
          onClose={() => setActiveConfig(null)}
          onSave={handleSaveMargins}
        />
      )}
    </>
  );
};
